<template>
  <div class="d-flex">
    <v-menu
      v-model="menuFrom"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          :dark="dark"
          readonly
          v-model="formattedDateFrom"
          hint="Von"
          persistent-hint
          prepend-icon="mdi-calendar"
          v-on="on"
        />
      </template>
      <v-date-picker
        v-model="dateFrom"
        no-title
        locale="de"
        @input="menuFrom = false; menuTo = true"
      />
    </v-menu>
    <v-menu
      v-model="menuTo"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          :dark="dark"
          readonly
          v-model="formattedDateTo"
          hint="Bis"
          persistent-hint
          prepend-icon="mdi-calendar"
          v-on="on"
        />
      </template>
      <v-date-picker
        v-model="dateTo"
        no-title
        locale="de"
        @input="menuTo = false"
      />
    </v-menu>
  </div>
</template>

<script>

import moment from 'moment';

export default {
  name: 'DateRangeSelection',
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    dateFrom(newVal) {
      this.dateFromChanged(newVal);
    },
    dateTo(newVal) {
      this.dateToChanged(newVal);
    },
  },
  computed: {
    formattedDateFrom() {
      return this.dateFrom
        ? this.getUtcDate(this.dateFrom).format('MMMM Do YYYY')
        : '';
    },
    formattedDateTo() {
      return this.dateTo
        ? this.getUtcDate(this.dateTo).format('MMMM Do YYYY')
        : '';
    },
  },
  methods: {
    clear() {
      this.dateFrom = null;
      this.dateTo = null;
    },
    notifyChanged() {
      const fromUtc = this.getUtcDate(this.dateFrom, 'start');
      const from = fromUtc ? fromUtc.format() : null;
      const toUtc = this.getUtcDate(this.dateTo, 'end');
      const to = toUtc ? toUtc.format() : null;

      this.$emit('changed', { from, to });
    },
    dateFromChanged() {
      this.menuTo = true;
      this.notifyChanged();
    },
    dateToChanged() {
      this.menuTo = false;
      this.notifyChanged();
    },
    getUtcDate(date, partOfDay) {
      if (!date) {
        return null;
      }

      const dateMoment = moment.utc(date, 'YYYY-MM-DD');
      return partOfDay === 'end'
          ? dateMoment.endOf('day')
          : dateMoment.startOf('day');
    },
  },
  data: () => ({
    dateFrom: null,
    dateTo: null,
    menuFrom: false,
    menuTo: false,
  }),
};
</script>
